import { render } from "./Settlement.vue?vue&type=template&id=5ccaebb6&scoped=true&ts=true"
import script from "./Settlement.vue?vue&type=script&lang=ts"
export * from "./Settlement.vue?vue&type=script&lang=ts"

import "./Settlement.vue?vue&type=style&index=0&id=5ccaebb6&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccaebb6"]])

export default __exports__